import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portal-subscription',
  templateUrl: './portal-subscription.component.html',
  styleUrls: ['./portal-subscription.component.scss']
})
export class PortalSubscriptionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
